<div class="progress-donut-wrapper">
  <svg
    class="svg-indicator"
    [style.width]="size + 'px'"
    [style.height]="size + 'px'"
  >
    <circle
      class="svg-indicator-track"
      [style.cx]="center + 'px'"
      [style.cy]="center + 'px'"
      [style.r]="radius + 'px'"
      [style.stroke-width]="strokeWidth + 'px'"
    />
    <circle
      class="svg-indicator-indication"
      [style.cx]="center + 'px'"
      [style.cy]="center + 'px'"
      [style.r]="radius + 'px'"
      [style.stroke-width]="strokeWidth + 'px'"
      [style.stroke-dasharray]="dashArray + 'px'"
      [style.stroke-dashoffset]="getDashOffset() + 'px'"
    />
  </svg>
  <span>
    <ng-content />
  </span>
</div>
